import { createFileRoute } from "@tanstack/react-router";
import { TicketDetailShell } from "@/features/tickets/detail/TicketDetailShell";

export const Route = createFileRoute("/_authenticated/tickets/$ticketId")({
  component: TicketDetailPage,
});

function TicketDetailPage() {
  const { ticketId } = Route.useParams();
  return <TicketDetailShell ticketId={ticketId} />;
}
